import { Link } from "react-router-dom";
import { useTranslation } from "../../../i18n/LanguageProvider";

function NewsBreadcrumb({ title }) {
    const { localizedPath, t } = useTranslation();

    return (
        <nav className="news-detail__breadcrumb">
            <Link to={localizedPath("/")}>{t("profile.home")}</Link>
            <span>/</span>
            <Link to={localizedPath("/noutati")}>{t("news.title")}</Link>
            {title && (
                <>
                    <span>/</span>
                    <span>{title}</span>
                </>
            )}
        </nav>
    );
}

export default NewsBreadcrumb;
